/**
 * Tests a provided value against a ValueType
 */var testValueType=function testValueType(v){return function(type){return type.test(v);};};export{testValueType};